import {
  ConfigurationFormType,
  ConfigurationPageTab,
  ConfigurationPageTables,
  ConfigurationPageType,
  ConfigurationTableFilterType,
  tableTabAt,
} from "../interfaces";
import { SURQUAL_GRID_TYPE_PAGE } from "./SURQUAL_GRID_TYPE";
import { SURQUAL_UH_CAT_PAGE } from "./SURQUAL_UH_CAT";

const MAPPING_COMPETITOR_PROPERTY_DATAFEED: ConfigurationPageTables = {
  description: "CONF_DESC_MAPPING_COMPSET",
  type: ConfigurationPageType.TABLE,
  path: "competitor-properties",
  label: "COMPETITOR_PROPERTY_DATAFEED",
  model: {
    entityName: "property_datafeed",
    label: "COMPETITOR_PROPERTY_DATAFEED",
    path: "/api/mapping/competitors",
    bulkPath: "/api/mapping/competitors/bulk-updates",
    name: "Competitor property datafeed",
    attributes: [
      {
        key: "property_datafeed",
        order: 1,
        label: "PROPERTY_DATAFEED",
        visible: true,
      },
      {
        key: "competitor_datafeed",
        order: 2,
        label: "COMPETITOR_DATAFEED",
        visible: true,
      },
      {
        key: "connector",
        order: 3,
        label: "COMPETITOR_CONNECTOR_CODE",
        visible: true,
      },
      {
        key: "description",
        order: 4,
        label: "COMPETITOR_LABEL",
        visible: true,
      },
      {
        key: "competitor_property.description",
        order: 5,
        label: "COMPETITOR",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/mapping/competitors/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/mapping/competitors/export" },
  },
  options: {
    formFields: [
      {
        key: "property_datafeed",
        label: "PROPERTY_DATAFEED",
        type: ConfigurationFormType.Input,
      },
      {
        key: "competitor_datafeed",
        label: "COMPETITOR_DATAFEED",
        type: ConfigurationFormType.Input,
      },
      {
        key: "competitor_property",
        label: "COMPETITOR",
        labelKey: "description",
        type: ConfigurationFormType.Select,

        api: "/api/competitors/",
        apiParams: {
          page_size: 100,
          ordering: "description",
        },
      },
      {
        key: "connector",
        label: "COMPETITOR_CONNECTOR_CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "description",
        label: "DESCRIPTION",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: false,
    // createOptions: [
    //   {
    //     key: "property_datafeed",
    //     flex: "50%",
    //     required: true,
    //   },
    //   {
    //     key: "competitor_datafeed",
    //     flex: "50%",
    //     required: true,
    //   },
    //   {
    //     key: "description",
    //     flex: "100%",
    //     required: true,
    //   },
    //   {
    //     key: "competitor_property",
    //     flex: "100%",
    //     required: true,
    //   },
    // ],
    deletable: false,
    editable: true,
    editOptions: [
      {
        key: "property_datafeed",
        flex: "50%",
        required: true,
        readonly: true,
      },
      {
        key: "competitor_datafeed",
        flex: "50%",
        required: true,
        readonly: true,
      },
      {
        key: "connector",
        flex: "100%",
        required: true,
        readonly: true,
      },
      {
        key: "description",
        flex: "100%",
        required: false,
        readonly: true,
      },
      {
        key: "competitor_property",
        flex: "100%",
        required: true,
      },
    ],
  },
};

const MAPPING_COMPETITOR_UH_CAT_DATAFEED: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  path: "competitor-uh-cats",
  label: "COMPETITOR_UH_CAT_DATAFEED",
  model: {
    entityName: "competitor_uh_cat_datafeed",
    label: "COMPETITOR_UH_CAT_DATAFEED",
    path: "/api/mapping/competitor-uh-cats",
    bulkPath: "/api/mapping/competitor-uh-cats/bulk-updates",
    name: "Competitor uh cat datafeed",
    attributes: [
      {
        key: "competitor_property_datafeed.description",
        order: 1,
        label: "COMPETITOR_LABEL",
        visible: true,
      },
      {
        key: "datafeed",
        order: 2,
        label: "DATA_FEED_CODE",
        visible: true,
      },
      {
        key: "connector",
        order: 3,
        label: "COMPETITOR_CONNECTOR_CODE",
        visible: true,
      },
      {
        key: "description",
        order: 4,
        label: "DESCRIPTION",
        visible: true,
      },
      {
        key: "uh_cat.short_name",
        order: 5,
        label: "UH_CAT",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/mapping/competitor-uh-cats/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/mapping/competitor-uh-cats/export" },
  },
  options: {
    formFields: [
      {
        key: "competitor_property_datafeed",
        label: "COMPETITOR_PROPERTY_DATAFEED",
        labelKey: "description",
        type: ConfigurationFormType.Select,
        api: "/api/mapping/competitors/",
        apiParams: {
          page_size: 100,
          ordering: "description",
        },
      },
      {
        key: "uh_cat",
        label: "UH_CAT",
        labelKey: "short_name",
        type: ConfigurationFormType.Select,
        api: "/api/uh-cats/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
          competitor_uh_cat: {
            path: "id",
          },
        },
        subCreationForm: tableTabAt(SURQUAL_UH_CAT_PAGE.tabs, 0),
      },
      {
        key: "datafeed",
        type: ConfigurationFormType.Input,
        label: "DATA_FEED_CODE",
      },
      {
        key: "connector",
        type: ConfigurationFormType.Input,
        label: "COMPETITOR_CONNECTOR_CODE",
      },
      {
        key: "description",
        type: ConfigurationFormType.Input,
        label: "DESCRIPTION",
      },
    ],
    copyable: false,
    creatable: false,
    // createOptions: [
    //   {
    //     key: "competitor_property_datafeed",
    //     flex: "100%",
    //     readonly: false,
    //   },
    //   {
    //     key: "datafeed",
    //     flex: "100%",
    //     required: true,
    //   },
    //   {
    //     key: "description",
    //     flex: "100%",
    //     required: false,
    //   },
    //   {
    //     key: "uh_cat",
    //     flex: "100%",
    //     readonly: false,
    //   },
    // ],
    deletable: false,
    editable: true,
    editOptions: [
      {
        key: "competitor_property_datafeed",
        flex: "100%",
        readonly: true,
      },
      {
        key: "datafeed",
        flex: "100%",
        readonly: true,
      },
      {
        key: "description",
        flex: "100%",
        readonly: true,
      },
      {
        key: "uh_cat",
        flex: "100%",
        readonly: false,
      },
    ],
    editSelectedOptions: [
      {
        key: "uh_cat",
        flex: "100%",
      },
    ],
  },
};

const MAPPING_COMPETITOR_GRID_TYPE_DATAFEED: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  path: "competitor-grid-types",
  label: "COMPETITOR_GRID_TYPE_DATAFEED",
  model: {
    entityName: "property_datafeed",
    label: "COMPETITOR_GRID_TYPE_DATAFEED",
    path: "/api/mapping/competitor-grid-types",
    bulkPath: "/api/mapping/competitor-grid-types/bulk-updates",
    name: "Competitor grid type datafeed",
    attributes: [
      {
        key: "competitor_property_datafeed.description",
        order: 1,
        label: "COMPETITOR_LABEL",
        visible: true,
      },
      {
        key: "datafeed",
        order: 2,
        label: "DATA_FEED_CODE",
        visible: true,
      },
      {
        key: "connector",
        order: 3,
        label: "COMPETITOR_CONNECTOR_CODE",
        visible: true,
      },
      {
        key: "description",
        order: 4,
        label: "DESCRIPTION",
        visible: true,
      },
      {
        key: "grid_type.code",
        order: 5,
        label: "GRID_TYPE",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/mapping/competitor-grid-types/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/mapping/competitor-grid-types/export" },
  },
  options: {
    formFields: [
      {
        key: "competitor_property_datafeed",
        label: "COMPETITOR_PROPERTY_DATAFEED",
        labelKey: "description",
        type: ConfigurationFormType.Select,
        api: "/api/mapping/competitors/",
        apiParams: {
          page_size: 100,
          ordering: "description",
        },
      },
      {
        key: "grid_type",
        label: "GRID_TYPE",
        labelKey: "label",
        type: ConfigurationFormType.Select,
        api: "/api/grid-types/",
        apiParams: {
          page_size: 100,
          ordering: "label",
        },
        subCreationForm: tableTabAt(SURQUAL_GRID_TYPE_PAGE.tabs, 0),
      },
      {
        key: "datafeed",
        type: ConfigurationFormType.Input,
        label: "DATA_FEED_CODE",
      },
      {
        key: "connector",
        type: ConfigurationFormType.Input,
        label: "COMPETITOR_CONNECTOR_CODE",
      },
      {
        key: "description",
        type: ConfigurationFormType.Input,
        label: "DESCRIPTION",
      },
    ],
    copyable: false,
    creatable: false,
    // createOptions: [
    //   {
    //     key: "competitor_property_datafeed",
    //     flex: "100%",
    //     required: true,
    //   },
    //   {
    //     key: "datafeed",
    //     flex: "100%",
    //     required: true,
    //   },
    //   {
    //     key: "description",
    //     flex: "100%",
    //     required: false,
    //   },
    //   {
    //     key: "grid_type",
    //     flex: "100%",
    //     required: true,
    //   },
    // ],
    deletable: false,
    editable: true,
    editOptions: [
      {
        key: "competitor_property_datafeed",
        flex: "100%",
        readonly: true,
      },
      {
        key: "datafeed",
        flex: "100%",
        readonly: true,
      },
      {
        key: "description",
        flex: "100%",
        readonly: true,
      },
      {
        key: "grid_type",
        flex: "100%",
        readonly: false,
        required: true,
      },
    ],
    editSelectedOptions: [
      {
        key: "grid_type",
        flex: "100%",
      },
    ],
  },
};

export const MAPPING_COMPETITOR_PAGE: ConfigurationPageTab = {
  type: ConfigurationPageType.TABS,
  count: 0,
  description: "CONF_PAGE_DESC_DEFAULT",
  label: "COMPETITOR_MAPPING",
  flagDisabled: "is_new_competitor_management",
  pageLabel: "COMPETITOR_TITLE_MAPPING",
  menuLabel: "COMPETITOR",
  name: "competitor",
  path: "competitor",
  tabs: [
    MAPPING_COMPETITOR_PROPERTY_DATAFEED,
    MAPPING_COMPETITOR_UH_CAT_DATAFEED,
    MAPPING_COMPETITOR_GRID_TYPE_DATAFEED,
  ],
};
